<a [routerLink]="getDetailLink()" [state]="getRouterState()" class="card-link">
  <div class="card-image-wrapper">
    <!-- <button
      class="favorite-btn"
      (click)="toggleFavorite($event)"
      [title]="isFavorite() ? 'Remove from Favorites' : 'Add to Favorites'"
      style="
        position: absolute;
        top: 10px;
        right: 10px;
        background: rgba(255,255,255,0.9);
        border: none;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;
        box-shadow: 0 2px 4px rgba(0,0,0,0.15);
        color: #ef4444;
        font-size: 1.1rem;
        transition: transform 0.2s;
      "
    >
      <i class="fa-heart" [class.fas]="isFavorite()" [class.far]="!isFavorite()"></i>
    </button> -->
    <img [src]="imageUrl" [alt]="productName" (error)="handleImageError($event)" loading="lazy" />
    <!-- <div class="badge sale" *ngIf="productTypeLabel === 'boat'">{{ boatTypeName }}</div> -->
    <!-- <div class="badge apparel" *ngIf="productTypeLabel === 'merchandise'">Apparel</div> -->
  </div>

  <div class="card-content">
    <div class="title-rating-row">
      <h3 class="product-title">{{ productName }}</h3>
      <div class="product-rating" *ngIf="product.averageRating">
        <i class="fas fa-star star"></i>
        <span class="rating-val">{{ product.averageRating | number: '1.1-1' }}</span>
        <span class="review-count">({{ product.reviewCount || 0 }} reviews)</span>
      </div>
    </div>

    <div
      class="price-status-row"
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.5rem;
      "
    >
      <p class="product-price" style="margin-bottom: 0">{{ product.price | currency }}</p>
      <span class="status-badge" [ngClass]="statusClass">
        {{ statusLabel }}
      </span>
    </div>

    <div class="product-meta" *ngIf="productDescription">
      <div class="truncate" [innerHTML]="productDescription"></div>
    </div>

    <div class="card-actions">
      <button
        class="btn-interest"
        *ngIf="productTypeLabel === 'boat'"
        (click)="onInterested($event)"
      >
        I'm Interested
      </button>

      <div class="share-container">
        <button
          class="btn-share-trigger"
          (click)="
            isSharePopupOpen.set(!isSharePopupOpen());
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          Share
          <i
            class="fas"
            [class.fa-chevron-down]="!isSharePopupOpen()"
            [class.fa-chevron-up]="isSharePopupOpen()"
            style="font-size: 0.7rem"
          ></i>
        </button>

        <div class="share-dropdown" [class.share-open]="isSharePopupOpen()">
          <button (click)="shareTo('facebook', $event)" class="share-menu-item">
            <i class="fab fa-facebook-f fb"></i> Facebook
          </button>
          <button (click)="shareTo('instagram', $event)" class="share-menu-item">
            <i class="fab fa-instagram insta"></i> Instagram
          </button>
          <button (click)="shareTo('twitter', $event)" class="share-menu-item">
            <i class="fa-brands fa-x-twitter">x</i> X
          </button>
          <button (click)="shareTo('whatsapp', $event)" class="share-menu-item">
            <i class="fab fa-whatsapp wa"></i> WhatsApp
          </button>
          <div class="divider"></div>
          <button (click)="onShare($event)" class="share-menu-item">
            <i class="fas fa-link link"></i> Copy Link
          </button>
          <p *ngIf="shareStatus()" role="status" aria-live="polite" class="share-status">{{ shareStatus() }}</p>
        </div>
      </div>
    </div>
  </div>
</a>
